module.exports = __webpack_public_path__ + "img/C11.9c9f9ed3.png";